import { jsx } from "react/jsx-runtime";
import { g as getIcon } from "../../Icon.js";
const Pause = ({ size, isHovered }) => {
  const normal = /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("path", { d: "M27.447 31.959h3V16.04h-3zM17.553 31.959h3V16.04h-3z" }) });
  const normalHover = /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("path", { d: "M27.447 34.486h3V13.513h-3zM17.553 34.486h3V13.513h-3z" }) });
  const xSmall = /* @__PURE__ */ jsx("path", { d: "M26.817 31.827h3.998V15.91h-3.998v15.918zm-9.894 0h3.997V15.91h-3.997v15.918z" });
  const xSmallHover = /* @__PURE__ */ jsx("path", { d: "M26.817 34.355h3.998V13.383h-3.998v20.972zm-9.894 0h3.997V13.383h-3.997v20.972z" });
  return getIcon({ size, isHovered, normal, normalHover, xSmall, xSmallHover });
};
export {
  Pause as default
};
//# sourceMappingURL=Pause.js.map
